export default "__VITE_ASSET__BFzYPcoe__"